import React, {Component} from 'react'
import { submit, isSubmitting } from 'redux-form'
import { connect } from 'react-redux'
import {
  TextInput,
  fetchEnd,
  fetchStart,
  required,
  showNotification,
  SimpleForm,
  SaveButton
} from 'react-admin'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Slide from '@material-ui/core/Slide'

import axiosClient from '../../../config/axios'
import { toggleEditPasswordModal } from '../../../redux/actions/modals'
import CancelButton from '../../../components/CancelButton'

const FORM_NAME = 'edit-password'

function Transition (props) {
  return <Slide direction='up' {...props} />
}

class EditPassword extends Component {
  constructor (props) {
    super(props)

    this._submit = this._submit.bind(this)
  }

  async _submit (values) {
    const { fetchStart, fetchEnd, showNotification } = this.props
    try {
      // Dispatch an action letting react-admin know a API call is ongoing
      fetchStart()

      await axiosClient()
        .put(`/password/${this.props.record._id}`, {
          password: values.newPassword
        })

      this.props.toggleEditPasswordModal()
      showNotification('Password edit successful', 'info')
      fetchEnd()
    } catch (err) {
      showNotification(err.message, 'error')
      fetchEnd()
    } finally {
      fetchEnd()
    }
  }

  render () {
    return (
      <Dialog
        fullScreen={window.innerWidth < 600}
        open={this.props.isOpen}
        onClose={this.props.toggleEditPasswordModal}
        TransitionComponent={window.innerWidth < 600 ? Transition : undefined}
      >
        <DialogTitle>Edit password</DialogTitle>
        <DialogContent>
          <SimpleForm
            form={FORM_NAME}
            onSubmit={this._submit}
            toolbar={null}
            validate={validate}
          >
            <TextInput
              source='newPassword'
              type='password'
              validate={required()}
              resettable
            />
            <TextInput
              source='repeatPassword'
              type='password'
              validate={required()}
              resettable
            />
          </SimpleForm>
        </DialogContent>
        <DialogActions>
          <CancelButton
            onClick={this.props.toggleEditPasswordModal}
          />
          <SaveButton
            saving={this.props.isSubmitting}
            onClick={() => this.props.submit(FORM_NAME)}
          />
        </DialogActions>
      </Dialog>
    )
  }
}

const validate = (values) => {
  const errors = {}
  if (values.newPassword && values.newPassword.length < 8) {
    errors.newPassword = 'Passwords is too short'
  }
  if (values.newPassword !== values.repeatPassword) {
    errors.repeatPassword = 'Passwords do not match'
  }
  return errors
}

const mapStateToProps = (state) => ({
  ...state.modals.editPassword,
  isSubmitting: isSubmitting(FORM_NAME)(state)
})

export default connect(mapStateToProps, {
  toggleEditPasswordModal,
  fetchEnd,
  fetchStart,
  showNotification,
  submit
})(EditPassword)
